<template>
  <div class="container">
    <!-- 搜索框 -->
    <section class="search_box">
      <section class="search_box_inpt">
        <img class="search_icon" src="../../assets/images/search.png" />
        <input
          type="text"
          placeholder="请输入姓名或手机号搜索"
          v-model="key"
          @input="inputFun"
        />
        <img
          class="clear_img"
          @click.stop="searchClear"
          v-if="key.length"
          src="../../assets/images/btn_clear.png"
        />
      </section>
      <span class="search_btn" v-if="key.length" @click="goback">取消</span>
    </section>
    <!-- 搜索结果 -->
    <section class="search_main">
      <section
        class="list_item"
        v-for="(item,index) in dataList"
        :key="index"
      >
        <section class="list_item_left">
          <img src="../../assets/images/img_list_head.png" />
        </section>
        <section class="list_item_center">
          <p>{{item.name}}</p>
          <span>{{item.phone}}</span>
        </section>
        <section class="list_item_right">
          <mt-button class="dispatch" @click.stop="dispatch(item)">派单</mt-button>
        </section>
      </section>
      <!-- 搜索结果显示 -->
      <span class="search_status" v-if="searchEnd == '1' && key.length != 0">无搜索结果</span>
      <section class="search_loading" v-if="searchEnd == '2' && key.length != 0">
        <img class="search_icon" src="../../assets/images/icon_loading.png" />
        <span>正在搜索...</span>
      </section>
    </section>
  </div>
</template>

<script>
import util from "../../utils/util";
import { getIntServWorkerList, updateIntServOrder } from "../../utils/api";
import { mapState } from "vuex";
let timer = "";
export default {
  name: "houseDispatch",
  data() {
    return {
      key: "",
      dataList: [],
      serviceType:'',
      searchEnd: 0 ,//搜索结果状态
      peopleType:1
    };
  },
  filters: {
    timeType(val) {
      return util.formatTime(new Date(Number(val)), 4);
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    let query = this.$route.query;
    if(query.serviceType){
      this.serviceType =decodeURIComponent(query.serviceType)
    }
    if(query.peopleType){
      this.peopleType=query.peopleType;
    }
    if(this.peopleType==1){
      this.$route.meta.title='指派服务人员'
    }else{
      this.$route.meta.title='派单给主管'
    }
    document.title = this.$route.query.title || '';
    this.getIntServWorkerList();
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    // 点击清空图标
    searchClear() {
      this.key = "";
      this.searchEnd = 0;
      this.dataList = [];
    },
    inputFun() {
      //键盘输入时触发input事件
      clearTimeout(timer);
      var that = this;
      that.dataList = [];
      if (that.key.length === 0 && that.key.length === 0) {
        //如果输入框为空
        that.searchEnd = 0;
      } else {
        this.searchEnd = 2;
        timer = setTimeout(function() {
          that.getIntServWorkerList();
        }, 800);
      }
    },
    toPolicyDetail() {
    },
    getIntServWorkerList() {
      util.showLoading()
      var that = this;
      let header = {}
      if(this.$route.query.marketid){
        header.marketId = this.$route.query.marketid
      }
      if(this.$route.query.cityId){
        header.cityId = this.$route.query.cityId
      }
      getIntServWorkerList({
        keyword:this.key,
        serviceType:this.serviceType,
        peopleType:this.peopleType,
        },header).then(res => {
        console.log(res);
        if (res.res.code === 10000 && res.body ) {
          let dataList =[];
          if(this.peopleType==1){
             dataList = res.body.intservWorkers || [];
          }else{
             dataList =res.body.intservWorkers ||[];
          }

          that.searchEnd = 0;
          that.dataList = dataList;
        } else {
          that.searchEnd = 1;
        }
        util.hideLoading();
      });
    },
    dispatch(item){
      util.showModal('',`确定要派单给${item.name}吗?`,true,'确定',()=>{
        let params = {
          id:this.$route.query.id,
          orderId:this.$route.query.orderId,
          // status:'7',//已派单
          // workerId:item.id,
          imgs:[]
        }
        if(this.peopleType==2){
          params.status='7';  //已派单
          params.workerId =item.id
        }else{
          params.status='9';  //待服务
          params.serverId =item.id

        }

        let header = {}
        if(this.$route.query.marketid){
          header.marketId = this.$route.query.marketid
        }
        if(this.$route.query.cityId){
          header.cityId = this.$route.query.cityId
        }
        util.showLoading()
        updateIntServOrder(params,header).then(res=>{
          console.log(res)
          util.hideLoading()
          if(res.res.code === 10000){
            util.showToast('派单成功')
            this.$router.go(-1)
          }else{
            util.showToast(res.res.msg)
          }
        })
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: #fff;
}
.search_box {
  padding: 26px 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 68px;
  .flex();
  align-items: center;
  background:#fff;
  z-index:2;
  .search_btn {
    font-size: 28px;
    color: rgba(51, 51, 51, 1);
    display: block;
    padding: 0 32px 0 40px;
  }
  .search_box_inpt {
    flex: 1;
    height: 68px;
    background: rgba(244, 244, 244, 1);
    border-radius: 8px;
    position: relative;
    .flex();
    align-items: center;
    .search_icon {
      width: 44px;
      height: 44px;
      display: block;
      margin: 0 14px;
    }
    input {
      flex: 1;
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
      background: transparent;
      height: 68px;
    }
    .clear_img {
      position: absolute;
      width: 44px;
      height: 44px;
      padding: 12px;
      top: 0;
      right: 0;
    }
  }
}
.search_main {
  margin-top: 120px;
  .search_status {
    display: block;
    text-align: center;
    margin-top: 28px;
    font-size: 28px;
    color: rgba(153, 153, 153, 1);
    line-height: 40px;
  }
  .search_loading {
    margin-top: 28px;
    .flex();
    justify-content: center;
    img {
      display: block;
      width: 32px;
      height: 32px;
      margin-right: 14px;
      animation: loading 1.4s linear infinite;
    }
  }
}
@keyframes loading {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.list_item {
  padding: 28px;
  .borderB();
  .flex();
  align-items: center;
  .list_item_left {
    margin-right: 24px;
    img {
      width: 80px;
      height: 80px;
      display: block;
    }
  }
  .list_item_center {
    flex: 1;
    p {
      height: 40px;
      font-size: 28px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 40px;
      .textOver(100%);
      margin-bottom: 8px;
    }
    span {
      height: 34px;
      font-size: 24px;
      color: rgba(153, 153, 153, 1);
      line-height: 34px;
    }
  }
  .list_item_right {
    .dispatch {
      width: 128px;
      height: 52px;
      background: rgba(243, 245, 253, 1);
      border-radius: 4px;
      .border(@color17);
      text-align:center;
      line-height: 52px;
      box-sizing: border-box;
      font-size:26px;
      color:@color17;
    }
  }
}
</style>